import React from 'react';
import { QueryClient, useMutation } from 'react-query';
import { update } from '../../../../../services/request/assets';
import { ISystemTypeBase } from '../../../../api-client';

export interface IMutationMulti {
  messageKey: string;
}

export interface IUseCrudMulti {
  queryClient: QueryClient;
  queryClientKey: string;
}

const useMultiUpdate = ({ queryClient, queryClientKey }: IUseCrudMulti) => {
  const updateMultiMutation = useMutation(update);

  const handlerUpdate = async (
    data: any[],
    rowChecked: string[],
    payload: any,
    cb?: (entity: any, payload: any) => any
  ) => {
    const promises: Promise<any>[] = [];
    const successRows: string[] = [];
    const errorRows: string[] = [];
    data.forEach((entity: ISystemTypeBase): void => {
      if (rowChecked.indexOf(entity['@id']) !== -1) {
        const updatedPayload = cb ? cb(entity, payload) : payload;
        const ret = updateMultiMutation
          .mutateAsync({
            data: { ...updatedPayload },
            iri: entity['@id'],
          })
          .then(resp => {
            successRows.push(entity['@id']);
            return resp;
          })
          .catch(error => {
            errorRows.push(entity['@id']);
            return error;
          });
        promises.push(ret);
      }
    });
    const res = await Promise.all(promises);

    queryClient.invalidateQueries(queryClientKey).then(() => null);

    return { res, successRows, errorRows };
  };

  return { handlerUpdate };
};

export default useMultiUpdate;
